import styled from "styled-components";

export const MerchantLogo = styled.img`
  height: auto;
  width: auto;
  max-width: 200px;
  max-height: 85px;
  object-fit: contain;
  object-position: center;
  display: block;
`;
